module.exports = "<ng-container *ngIf=\"chatService.getShowUnreadMessageBubble()\">\n    <div class=\"bubble\"></div>\n</ng-container>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/chat-unread-bubble/chat-unread-bubble.component.html
// module id = 589
// module chunks = 0